<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/config/customer/dictionaryTemplate/item/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<template #conditions>
				
				</template>
				<!-- 左侧按钮插槽 -->
				<template #buttonsL>
					<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
						{{$t('xinzeng')}}
					</el-button>
				</template>
				<!-- 操作插槽 -->
				<template #caozuo="scope">
					<el-row :gutter="10">
						<el-col :span="0.1">
							<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}</el-button>
						</el-col>
						<el-col :span="0.1">
							<el-button type="text" class="font-color-danger"
								@click="yt.remove(scope.row,'/web/config/customer/dictionaryTemplate/item/delete')">{{$t('shanchu')}}
							</el-button>
						</el-col>
					</el-row>
				</template>
		</yi_curd_table>
			<!-- 新增/编辑弹框 -->
			<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
				:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
				<!-- 新增表单 -->
				<template v-if="yt.editObj.action == 'xinzeng'">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('zidianzhibianma')" required>
							<el-input v-model="yt.editObj.value"></el-input>
						</el-form-item>
						<el-form-item :label="$t('zidianzhimingcheng')" required>
							<el-input v-model="yt.editObj.label"></el-input>
						</el-form-item>
						<el-form-item :label="$t('shunxu')">
							<el-input v-model="yt.editObj.priority"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/customer/dictionaryTemplate/item/create',beforeAdd)"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
				</template>
				<!-- 更新表单 -->
				<template v-if="yt.editObj.action == 'bianji'">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item class="noborder" :label="$t('zidianzhibianma')" required>
						<el-input disabled v-model="yt.editObj.value"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zidianzhimingcheng')" required>
						<el-input v-model="yt.editObj.label"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shunxu')">
						<el-input v-model="yt.editObj.priority"></el-input>
					</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/customer/dictionaryTemplate/item/update')"
							type="primary">{{$t('baocun')}}
						</el-button>
					</span>
				</template>
			</el-dialog>
	</div>
</template>

<script type="text/javascript">
	// import curd_data from '@/common/curd/curd_data';
	export default {
		name: 'admin_data_template_dictionary_item',
		data() {
			return {
				columns: [{
					label: 'zidianzhibianma',
					prop: 'value',
					width: 150,
				}, {
					label: 'zidianzhimingcheng',
					prop: 'label',
					width: 150,
				}, {
					label: 'shunxu',
					prop: 'priority',
				},{
					label: 'caozuo',
					type: 'slot',
					width: 150,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {
					typeId: this.$attrs.typeId.id,
					pageNum: 1,
					pageSize: 10,
					orderBy:'priority',
				}
				this.yt.get(1);
			}, 300)		
		},
		methods: {
			// 字典值新增
			 beforeAdd(params, url) {
				 params.typeId = this.$attrs.typeId.id
			 	return params
			 },
		
		}
	};
</script>


<style>
</style>
